import { ReactComponent as LikedIcon } from "components/icons/likeIcon.svg";
import { ReactComponent as UnlikedIcon } from "components/icons/unliked.svg";
import { ReactComponent as SoundOnIcon } from "components/icons/soundOnIcon.svg";
import { ReactComponent as SoundOffIcon } from "components/icons/soundOffIcon.svg";
import "./LikeSoundOverlay.scss";

export const LikeSoundOverlay = () => {
  return (
    <div className="LikeSoundOverlay">
      <span className="liked"><LikedIcon /></span>
      <span className="unliked"><UnlikedIcon /></span>
      <span className="soundOn"><SoundOnIcon /></span>
      <span className="soundOff"><SoundOffIcon /></span>
    </div>
  );
};
